export default __webpack_public_path__ + "static/theia-screenshot-1523502d52358dd40d381c7f2969c9d0.png";